/* eslint-disable */
import * as humps from 'humps';
import axiosDeqart from '../axios';

const constructJobFiltersString = (filter = {}) => {
  let filterQueryParams = '';
  for (const key in filter) {
    if (filter[key]) {
      filterQueryParams += `&${humps.decamelize(key)}=${filter[key]}`;
    }
  }
  
  return filterQueryParams;
};

export const getJobs = (page, count, teamId, filter) => async () => {
  try {
    const jobsUrlBase = '/jobs';
    const filterQueryParams = constructJobFiltersString(filter);
    const jobsUrl = `${jobsUrlBase}?limit=${count}&offset=${page * count}${filterQueryParams}`;
    const { data } = await axiosDeqart.get(jobsUrl);
    return {
      jobs: data?.data || [],
      total: data?.totalCount,
    };
  } catch (err) {
    console.log('An error occurred while fetching user data---', err.message);
    return err;
  }
};

export const getJob = (jobId) => async () => {
  try {
    const { data } = await axiosDeqart.get(`/jobs/${jobId}`);
    return data?.data;
  } catch (err) {
    console.log(`An error occurred while fetching a job with ${jobId}`, err.message);
    throw err;
  }
};

export const cancelJob = async (jobId) => {
  try {
    const { data } = await axiosDeqart.patch('/jobs', {
      job_ids: [jobId],
      cancel: true,
    });
    return data?.data.some(job => job.jobId === jobId);
  } catch (err) {
    console.log(`An error occurred while cancelling a job with ${jobId}`, err.message);
    throw err;
  }
};
